import styled from 'styled-components';

import PrimitiveModal from '../Modal';

type ActionButtonProps = {
  isExpanded: boolean;
};

type ProductImageProps = {
  placeholder: string;
  url: string;
};

export const ActionButton = styled.button<ActionButtonProps>`
  height: 28px;
  width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 2px solid #e6effb;
  color: #101d40;
  background-color: transparent;

  svg {
    font-size: 18px;
  }

  &.add {
    background-color: #329bfc;
    border: none;
    color: #ffffff;
  }

  &.arrow {
    svg {
      transition: all 0.2s ease-in-out;
      transform: ${({ isExpanded }) =>
        isExpanded ? 'rotate(180deg)' : 'rotate(360deg);'};
    }
  }

  & + button {
    margin-left: -10px;
  }
`;

export const TableRow = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: minmax(250px, 1fr) 100px 100px 100px 161.2px 120px;
  border-top: 1px solid #e6effb;
  padding: 16px;
  align-items: center;
  background-color: #ffffff;
`;

export const TableCell = styled.div`
  &:not(:last-child):not(:first-child) {
    text-align: center;
  }

  &:last-child {
    margin-left: -15px;
  }

  p {
    font-weight: 500;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:nth-child(2) {
    width: 100px;
  }

  &:nth-child(3) {
    width: 100px;
  }

  &:nth-child(4) {
    width: 100px;
  }

  &:nth-child(5) {
    width: 165px;
  }

  &:nth-child(6) {
    width: 120px;
  }
`;

export const ProductDetails = styled.div`
  display: flex;
  align-items: center;
  width: 250px;

  button {
    border: none;
    background: none;
    margin-right: 16px;
    cursor: grab;

    svg {
      color: #101d40;
      font-size: 18px;
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.2;
    }
  }

  img {
    margin-right: 18px;
    width: 50px;
    min-width: 50px;
    height: 50px;
    border: 2px dashed #e6effb;
    border-radius: 5px;
    object-fit: contain;
  }

  p {
    white-space: initial;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    overflow: hidden;
    width: 300px;
  }
`;

export const Modal = styled(PrimitiveModal)`
  gap: 10px;
  position: relative;
  padding: 28px 32px;
  border-radius: 8px;
  max-width: 400px;
  font-family: 'Sora', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
    font-family: 'Sora', sans-serif;
    font-size: 14px;
    color: #7c8db5;
    margin-bottom: 10px;

    strong {
      color: #101d40;
      font-weight: 600;
      margin-top: 5px;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;

    svg {
      color: #f64444;
      font-size: 50px;
    }
  }

  h1 {
    color: #101d40;
    font-size: 24px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);

    svg {
      color: #4f4f4f;
      font-size: 22px;
    }

    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ProductImage = styled.div<ProductImageProps>`
  background-image: url(${({ placeholder }) => placeholder});
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 18px;
  width: 50px;
  min-width: 50px;
  height: 50px;
  border: 2px dashed #e6effb;
  border-radius: 5px;
  background-size: cover;

  div {
    height: 50px;
    width: 100%;

    background-image: url(${({ url }) => url}), url(${({ url }) => url});
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
